import { ref } from 'vue';
import { getSystemInfo } from '../api/system';

// 模块级单例，整个应用只请求一次
const systemInfo = ref(null);
let fetching = false;

export function useSystemInfo() {
  if (!systemInfo.value && !fetching) {
    fetching = true;
    getSystemInfo()
      .then((res) => {
        // 响应拦截器已解包 response.data，res 为 { code, data, ... }
        // 业务数据在 res.data：{ serverId, knowledgeVersionStrategy }
        systemInfo.value = res.data;
      })
      .catch(() => {
        // 请求失败时默认当作正式环境，不显示水印
        systemInfo.value = { serverId: 'prod', knowledgeVersionStrategy: 'published' };
      })
      .finally(() => {
        fetching = false;
      });
  }

  return { systemInfo };
}
